import { useQuery } from '@tanstack/react-query'
import { EntityWithIdAndDescription, SectorComercial, UnidadNegocio } from '../../../../../types'
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion'
import { OperacionLCTCClienteSubTipo, OperacionLCTCClienteTipo, OperacionLCTCLimiteTipo, OperacionLCTCRelacion, OperacionLCTCSectorComercial, OperacionLCTCUnidadNegocio } from "../types/dto";

export const useLCTCLimiteTipos = () => {
    const {
        data: limiteTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCTCLimiteTipo[], Error>({
        queryKey: ['LCTC-limite-tipos'],
        queryFn: () => HttpCacheOperacion.getLCTCLimiteTipos()
    })

    return {
        limiteTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCTCClienteSubTipos = (codClienteTipo: number | undefined | null) => {
    const {
        data: clienteSubTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCTCClienteSubTipo[], Error>({
        queryKey: ['LCTC-cliente-sub-tipos', codClienteTipo],
        queryFn: () => HttpCacheOperacion.getLCTCClienteSubTipos(codClienteTipo!),
        enabled: !!codClienteTipo
    })

    return { clienteSubTipos, isLoading, isError, error }
}

export const useLCTCClienteTipos = (codSectorComercial: number | undefined | null) => {
    const {
        data: clienteTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCTCClienteTipo[], Error>({
        queryKey: ['LCTC-cliente-tipos', codSectorComercial],
        queryFn: () => HttpCacheOperacion.getLCTCClienteTipos(codSectorComercial!),
        enabled: !!codSectorComercial
    })

    return {
        clienteTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCTCUnidadNegocioTipos = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: unidadNegocioTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<UnidadNegocio[], Error>({
        queryKey: ['LCTC-unidad-negocio-tipos', codPais, codSistema],
        queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
        enabled: !!codPais && !!codSistema
    })

    return {
        unidadNegocioTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCTCSectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: sectorComercialTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<SectorComercial[], Error>({
        queryKey: ['LCTC-sector-comercial-tipos', codUnidadNegocio, codSistema],
        queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
        enabled: !!codUnidadNegocio && !!codSistema
    })

    return {
        sectorComercialTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCTCRelacionTipos = (codSectorComercial: number | undefined | null) => {
    const {
        data: relaciones = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCTCRelacion[], Error>({
        queryKey: ['LCTC-relaciones', codSectorComercial],
        queryFn: () => HttpCacheOperacion.getLCTCRelacionTipos(codSectorComercial!),
        enabled: !!codSectorComercial
    })

    return {
        relaciones,
        isLoading,
        isError,
        error
    }
}
